import { useViewportSize } from '@mantine/hooks';
import { DependencyList, RefObject, useEffect, useRef, useState } from 'react';

//use it to limit element height from current position to viewport bottom
//useful if you want to have a scrollable element with full available height in viewport
// D.Zghinnik 25.09.2023
export const useCalculateElementMaxHeight = (
	// additional value in px to subtract from max height, like bottom paddings, margins, another components height, etc.
	bottomOffset = 0,
	dependency: DependencyList = [], //dependency list to recalculate height
	elementRef?: RefObject<HTMLDivElement | null>
) => {
	const ref = useRef<HTMLDivElement>(null);
	const { height } = useViewportSize();
	const [maxHeight, setMaxHeight] = useState<number>();

	useEffect(() => {
		const refToUse = elementRef ?? ref;

		const maxHeightValue = refToUse?.current?.offsetTop
			? height - refToUse.current.offsetTop - bottomOffset
			: undefined;
		setMaxHeight(maxHeightValue);
	}, [ref?.current?.offsetTop, elementRef?.current?.offsetTop, height, ...dependency]);

	return {
		ref,
		maxHeight,
	};
};
